module.exports = __webpack_public_path__ + "static/media/camel.f18825d0.svg";